import { NEW_PIXEL_POSITIONS_BY_FRAME } from '../constants';

// The width and height should be 1, but in that case, resulting non-integer values when zooming in browser
// cause the grid between the 8x8 pixels to be visible. This prevents that.
const generateSvgRect = (x: number, y: number) => `<rect x="${x}" y="${y}" width="1.125" height="1.125" fill="black"/>`;

const getRectPositionsAtStep = (step: number) => {
    const positions = NEW_PIXEL_POSITIONS_BY_FRAME.reduce((acc, curr, index) => {
        if (index <= step) {
            return [...acc, ...curr];
        }
        return acc;
    }, []);

    return positions;
};

export const getBackgroundUrl = (step: number) =>
    'url(data:image/svg+xml;utf8,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none"><rect width="8" height="8" fill="white"/>' +
            getRectPositionsAtStep(step)
                .map(([x, y]) => generateSvgRect(x, y))
                .join('') +
            '</svg>',
    ) +
    ')';
